import {Colors, Container, Text} from "@bounce/shared/ui";
import CloseIcon from "@mui/icons-material/Close";
import {Dialog, DialogContent, IconButton, Tab, Tabs} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import {useConsumerUser} from "~/contexts";
import {FeatureFlagsTab, getStoredOverrides} from "./feature-flags";
import {ResetAccountTab} from "./tabs";
import {DevToolsWidget} from "./DevToolsWidget";

const DevToolsPanel = () => {
  const {featureFlags, applyDevOverrides: onOverridesChange} = useConsumerUser();
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [overrideCount, setOverrideCount] = useState(() => Object.keys(getStoredOverrides()).length);

  const refreshOverrideCount = useCallback(() => {
    setOverrideCount(Object.keys(getStoredOverrides()).length);
  }, []);

  useEffect(() => {
    refreshOverrideCount();
  }, [open, refreshOverrideCount]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && (e.key === "D" || e.key === "F")) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleOverridesChange = useCallback(() => {
    refreshOverrideCount();
    onOverridesChange?.();
  }, [refreshOverrideCount, onOverridesChange]);

  return (
    <>
      {!hidden && <DevToolsWidget onClick={() => setOpen(true)} onClose={() => setHidden(true)} />}

      {overrideCount > 0 && !open && (
        <Container
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            bgcolor: Colors.orange._800,
            color: "white",
            px: 2,
            py: 1,
            borderRadius: 2,
            cursor: "pointer",
            zIndex: 9999,
          }}
        >
          <Text size={12} sx={{fontWeight: "bold", color: "white"}}>
            {overrideCount} Flag Override{overrideCount > 1 ? "s" : ""} Active
          </Text>
        </Container>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <Container row sx={{justifyContent: "space-between", p: 2, borderBottom: "1px solid #eee"}}>
          <Text variant="inter600" size={18}>
            Dev Tools
          </Text>
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Container>

        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          sx={{px: 2, borderBottom: "1px solid #eee"}}
        >
          <Tab label="Feature Flags" />
          <Tab label="Reset Account" />
        </Tabs>

        <DialogContent>
          {activeTab === 0 && <FeatureFlagsTab featureFlags={featureFlags} onOverridesChange={handleOverridesChange} />}
          {activeTab === 1 && <ResetAccountTab onClose={() => setOpen(false)} />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DevToolsPanel;
